import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaPrestamosListaComponent ($filter, $moment) {
  var $ctrl = this,
    filterBy = $filter('filter'),
    groupBy = $filter('groupBy'),
    orderBy = $filter('orderBy')

  $ctrl.$onChanges = $onChanges
  $ctrl.filtrar = filtrar

  function $onChanges (changes) {
    if (changes.data) {
      $ctrl.data = orderBy($ctrl.data, 'fecha')
        .map(function (item) {
          item.periodo = $moment(item.fecha).format('MMMM D')

          return item
        })

      filtrar()
    }
  }

  function filtrar () {
    $ctrl.lista = groupBy(filterBy($ctrl.data, $ctrl.filtro), 'periodo')
  }
}

module.component('financesPosicionbancariaPrestamosLista', {
  controller: FinancesPosicionbancariaPrestamosListaComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/prestamos/lista/component.js